import { render } from "./ModalSelectorTipoIncidencia.vue?vue&type=template&id=525f6961&scoped=true"
import script from "./ModalSelectorTipoIncidencia.vue?vue&type=script&lang=ts"
export * from "./ModalSelectorTipoIncidencia.vue?vue&type=script&lang=ts"

import "./ModalSelectorTipoIncidencia.vue?vue&type=style&index=0&id=525f6961&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-525f6961"

export default script